import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gw5km92dw: FaireProductEntity = {
  token: "p_6gw5km92dw",
  type: "product",
  name: "Matches • Art •Starry Night Van Gogh• Home Decor for Candles",
  brandToken: "b_6zicjtg87q",
  brandName: "Most Amazing",
  imageUrl:
    "https://cdn.faire.com/fastly/b1c39c3f10e0e15779cc82c8b1e3f9315ffbba01ef4de976ced3536a1d1649b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa3b6a6e3aa4bc3aa1124786db43214f7f34157aa41208713985cd4b5cc6b5a7.jpeg",
    "https://cdn.faire.com/fastly/0d36dfc98ab3b661f9f6ab8e1e3d8e1f1a94ea609bd2c422eaa4a2fd2bedddb8.jpeg",
  ],
  priceDollars: 1.66,
  description:
    "• Matches to elevate your home decor. Light your candles and incense with style.\n• These unique matchboxes feature Starry Night, the classic art of Vincent Van Gogh on both sides\n• Each box contains 20-23 matches and measures about  2.25”x1.5”x.5”\n\n• NOW AVAILABLE! - CUSTOMIZE a Matchbox with YOUR SHOP LOGO! https://www.faire.com/product/p_zdp5asfpuq",
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:22.787Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
